import React, { useEffect, useState } from 'react';
import { useReminders } from '../hooks/useReminders';
import * as ReactRouterDom from 'react-router-dom';
import { BellIcon } from './icons/BellIcon';

export const ReminderNotification: React.FC = () => {
    const { reminders } = useReminders();
    const navigate = ReactRouterDom.useNavigate();
    const location = ReactRouterDom.useLocation();
    const [acknowledged, setAcknowledged] = useState(false);

    useEffect(() => {
        setAcknowledged(false);
    }, [reminders]);

    const pendingReminders = reminders.filter(r => !r.isCompleted);
    const today = new Date().toISOString().slice(0, 10);
    const todayStart = new Date(today).getTime();

    const urgentReminders = pendingReminders.filter(r => {
        const dueDateStr = r.dueDate && typeof r.dueDate === 'string' ? r.dueDate.slice(0, 10) : '';
        if (!dueDateStr || !/^\d{4}-\d{2}-\d{2}$/.test(dueDateStr)) return false;
        const dueDateNum = new Date(dueDateStr + 'T00:00:00').getTime();
        if (isNaN(dueDateNum)) return false;
        return dueDateNum <= todayStart;
    });

    useEffect(() => {
        if (urgentReminders.length > 0 && !acknowledged && location.pathname !== '/lembretes') {
            try {
                const audioCtx = new (window.AudioContext || (window as any).webkitAudioContext)();
                if (audioCtx.state === 'suspended') {
                    // Browsers require interaction to play sound. If not allowed, it will fail silently here.
                } else {
                    const oscillator = audioCtx.createOscillator();
                    const gainNode = audioCtx.createGain();
                    oscillator.type = 'sine';
                    oscillator.frequency.setValueAtTime(880, audioCtx.currentTime); // A5
                    oscillator.frequency.setValueAtTime(1046.50, audioCtx.currentTime + 0.1); // C6
                    gainNode.gain.setValueAtTime(0.3, audioCtx.currentTime);
                    gainNode.gain.exponentialRampToValueAtTime(0.01, audioCtx.currentTime + 0.3);
                    oscillator.connect(gainNode);
                    gainNode.connect(audioCtx.destination);
                    oscillator.start();
                    oscillator.stop(audioCtx.currentTime + 0.3);
                }
            } catch (e) {
                console.error("Audio playback failed", e);
            }
        }
    }, [urgentReminders.length, acknowledged, location.pathname]);

    if (location.pathname === '/lembretes') return null; // Don't show while on the Lembretes page

    if (urgentReminders.length === 0 || acknowledged) return null;

    return (
        <div className="fixed top-20 right-6 z-50 animate-bounce-short">
            <div className="bg-yellow-50 dark:bg-yellow-900/30 border border-yellow-200 dark:border-yellow-800 shadow-lg rounded-xl p-4 max-w-sm flex">
                <div className="text-yellow-600 dark:text-yellow-500 mr-3 mt-0.5">
                    <BellIcon />
                </div>
                <div className="flex-1">
                    <h4 className="text-sm font-bold text-yellow-800 dark:text-yellow-400">
                        Lembretes Pendentes
                    </h4>
                    <p className="text-sm text-yellow-700 dark:text-yellow-500 mt-1">
                        Você tem {urgentReminders.length} lembrete(s) que vencem hoje ou estão atrasados.
                    </p>
                    <div className="mt-3 flex gap-3">
                        <button 
                            onClick={() => navigate('/lembretes')}
                            className="bg-yellow-500 hover:bg-yellow-600 text-white text-xs font-semibold px-3 py-1.5 rounded"
                        >
                            Ver Lembretes
                        </button>
                        <button 
                            onClick={() => setAcknowledged(true)}
                            className="text-yellow-600 dark:text-yellow-500 hover:underline text-xs"
                        >
                            Fechar
                        </button>
                    </div>
                </div>
            </div>
            
            {/* Audio tag for a sound effect (optional, maybe we can just create Audio object) */}
        </div>
    );
};
